import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

export const PageHeader = ({children}) => {
	return <PageHeaderStyle>{children}</PageHeaderStyle>;
};

PageHeader.propTypes = {
	children: PropTypes.node,
};

const PageHeaderStyle = Styled.h1`
    color: #535353;
    font-size: 20px;
    font-weight: 500;
    font-family: "neue-haas-grotesk-text","sans-serif";
    margin: 0;
`;
